import { comonDataApi } from '@/api/config-setup'
import { queryKeys } from '@/constant/common'
import { DecoderTypeConfiguration } from '@/types/commonData'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import toast from 'react-hot-toast'
import useTranslation from '@/hooks/useTranslation'

async function updateDecoder(payload: DecoderTypeConfiguration): Promise<void> {
  await comonDataApi.putDecoderType(payload)
}

function useUpdateDecoder() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  return useMutation(
    (payload: DecoderTypeConfiguration) => updateDecoder(payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKeys.controller])
        toast.success(t('decoderUpdateDecoderPurpose&ConfigurationSuccess'))
      },
      onError: (error: AxiosError<any>) => {
        toast.error(error?.response?.data?.Message)
      },
    },
  )
}

export default useUpdateDecoder
